/**
 * APIs FastAPI do gateway usam skip/limit com le ≤ 1000.
 */

export const API_MAX_PAGE_SIZE = 1000;

export function normalizeList(payload) {
  if (Array.isArray(payload)) return payload;
  if (!payload || typeof payload !== 'object') return [];
  return payload.data ?? payload.items ?? payload.results ?? [];
}

/**
 * @param {(params: { skip: number; limit: number }) => Promise<import('axios').AxiosResponse>} requestFn
 * @returns {Promise<any[]>}
 */
export async function fetchAllPages(requestFn, pageSize = API_MAX_PAGE_SIZE) {
  const limit = Math.min(Math.max(1, Number(pageSize) || API_MAX_PAGE_SIZE), API_MAX_PAGE_SIZE);
  let skip = 0;
  const all = [];
  while (true) {
    const res = await requestFn({ skip, limit });
    const batch = normalizeList(res.data);
    all.push(...batch);
    if (batch.length < limit) break;
    skip += limit;
  }
  return all;
}

/** Aceita axios (`{ data }`) ou lista já desempacotada pelo crud. */
export function unwrapServiceList(res) {
  if (Array.isArray(res)) return res;
  if (!res || typeof res !== 'object') return [];
  if (
    res.data !== undefined &&
    (res.status != null || res.headers != null || res.config != null)
  ) {
    return normalizeList(res.data);
  }
  return normalizeList(res);
}

/**
 * Pagina um `getList` de crud (axios ou array).
 * @param {(params: object) => Promise<any>} getList
 */
export async function fetchAllFromGetList(getList, extraParams = {}) {
  let skip = 0;
  const all = [];
  while (true) {
    const res = await getList({ ...extraParams, skip, limit: API_MAX_PAGE_SIZE });
    const batch = unwrapServiceList(res);
    all.push(...batch);
    if (batch.length < API_MAX_PAGE_SIZE) break;
    skip += API_MAX_PAGE_SIZE;
  }
  return all;
}
